const About = () => {
  return (
    <div className="p-8 text-center">
      <h2 className="text-2xl font-bold text-blue-700">About Us</h2>
      <p className="mt-4">
        ICCK Tampere is a multicultural church committed to worship and community.
      </p>
    </div>
  );
};

export default About;